"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = void 0;
exports.enhanceWithDeviceId = enhanceWithDeviceId;
exports.enhanceWithGuestToken = enhanceWithGuestToken;
exports.enhanceWithToken = enhanceWithToken;
exports.generateCacheKey = void 0;
exports.generateTraceId = generateTraceId;
exports.getQuery = getQuery;
exports.getSearchQuery = void 0;
exports.isMobile = isMobile;
exports.isNodeServer = isNodeServer;
var _uuid = require("uuid");
function enhanceWithToken(options, token) {
  return {
    ...options,
    headers: {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : null
    }
  };
}
function enhanceWithGuestToken(options, token) {
  return {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `guest-token ${token}`
    }
  };
}
function enhanceWithDeviceId(options, deviceId) {
  return {
    ...options,
    headers: {
      ...options.headers,
      deviceId: deviceId
    }
  };
}
function isMobile() {
  if (typeof document !== 'undefined') {
    return false;
  } else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return true;
  } else {
    return false;
  }
}
function getQuery(requestParams) {
  // console.log('===getQuery start', Date.now());
  if (requestParams) {
    let queryString = Object.keys(requestParams).length === 0 ? '' : '?';
    for (const key in requestParams) {
      if (requestParams[key] !== '') {
        if (queryString === '?') {
          queryString = queryString + key + '=' + requestParams[key];
        } else {
          queryString = queryString + '&' + key + '=' + requestParams[key];
        }
      }
    }
    // console.log('===getQuery end', Date.now());
    return queryString;
  }
  // console.log('===getQuery end', Date.now());
  return '';
}
const buildUrl = (url, parameters) => {
  let qs = '';
  for (const key in parameters) {
    const value = parameters[key];
    qs += encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
  }
  if (qs.length > 0) {
    qs = qs.substring(0, qs.length - 1);
    url = url + '?' + qs;
  }
  return url;
};
exports.buildUrl = buildUrl;
const generateCacheKey = (url, data) => {
  let key = url;
  if (data) {
    key += JSON.stringify(data);
  }
  return key;
};
exports.generateCacheKey = generateCacheKey;
const getSearchQuery = queryParams => {
  let queryString = '';
  for (const key in queryParams) {
    if (queryString === '') {
      queryString = '?q=';
      queryString = queryString + key + ':' + queryParams[key];
    } else {
      queryString = queryString + ':' + key + ':' + queryParams[key];
    }
  }
  return queryString;
};
exports.getSearchQuery = getSearchQuery;
function isNodeServer() {
  return typeof window === 'undefined';
}
function generateTraceId() {
  var _uuidv;
  const uuid = (_uuidv = (0, _uuid.v4)()) === null || _uuidv === void 0 ? void 0 : _uuidv.replace(/-/g, '');
  return uuid === null || uuid === void 0 ? void 0 : uuid.substring(0, 24);
}